import { useQuery } from '@tanstack/react-query'
import { dashboardAPI } from '../../api'
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts'

const COLORS = ['#8B1A4A', '#C9963A', '#D4A0A0', '#3D1A2E', '#B3265F']

function ReportsPage() {
  const { data: stats } = useQuery({
    queryKey: ['admin-stats'],
    queryFn: () => dashboardAPI.getStats(),
    select: (r) => r.data?.data,
  })
  const { data: revenue } = useQuery({
    queryKey: ['admin-revenue-full'],
    queryFn: () => dashboardAPI.getRevenue({ period: '3months' }),
    select: (r) => r.data?.data || [],
  })

  const PIE_DATA = stats?.service_breakdown?.slice(0, 5) || [
    { name: 'Haircut',   value: 78 },
    { name: 'Coloring',  value: 42 },
    { name: 'Facial',    value: 35 },
    { name: 'Nail Art',  value: 26 },
    { name: 'Bridal',    value: 12 },
  ]

  return (
    <div className="space-y-6">
      <h2 className="font-display text-salon-dark text-2xl font-bold">Reports & Analytics</h2>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl p-6 border border-salon-cream-dark">
          <h3 className="font-semibold font-body text-salon-dark mb-4">Revenue Trend (90 Days)</h3>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={revenue?.length ? revenue : DEMO_REV}>
              <CartesianGrid strokeDasharray="3 3" stroke="#F4EBE3" />
              <XAxis dataKey="date" tick={{ fontSize: 11, fontFamily: 'DM Sans' }} />
              <YAxis tick={{ fontSize: 11, fontFamily: 'DM Sans' }} />
              <Tooltip contentStyle={{ fontFamily: 'DM Sans', borderRadius: 12 }} />
              <Line type="monotone" dataKey="amount" stroke="#8B1A4A" strokeWidth={2.5} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-2xl p-6 border border-salon-cream-dark">
          <h3 className="font-semibold font-body text-salon-dark mb-4">Service Distribution</h3>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={PIE_DATA} cx="50%" cy="50%" outerRadius={90} dataKey="value" nameKey="name" label>
                {PIE_DATA.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip contentStyle={{ fontFamily: 'DM Sans', borderRadius: 12 }} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-2xl p-6 border border-salon-cream-dark lg:col-span-2">
          <h3 className="font-semibold font-body text-salon-dark mb-4">Monthly Bookings</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={DEMO_MONTHLY}>
              <CartesianGrid strokeDasharray="3 3" stroke="#F4EBE3" />
              <XAxis dataKey="month" tick={{ fontSize: 11, fontFamily: 'DM Sans' }} />
              <YAxis tick={{ fontSize: 11, fontFamily: 'DM Sans' }} />
              <Tooltip contentStyle={{ fontFamily: 'DM Sans', borderRadius: 12 }} />
              <Bar dataKey="bookings" fill="#C9963A" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  )
}

const DEMO_REV = Array.from({ length: 30 }, (_, i) => ({ date: `${i + 1}`, amount: Math.floor(Math.random() * 12000 + 5000) }))
const DEMO_MONTHLY = [
  { month: 'Jan', bookings: 120 },
  { month: 'Feb', bookings: 145 },
  { month: 'Mar', bookings: 162 },
  { month: 'Apr', bookings: 138 },
  { month: 'May', bookings: 175 },
  { month: 'Jun', bookings: 190 },
]

export default ReportsPage
